angular.module('property-deal')
    .controller('PropertyDealDialogController', function ($http, toastr, $scope, $rootScope, $uibModalInstance, data, User, PropertyDeal, Project, PropertyService, PropertyDealService, LeadService, PropertyDealBuyerMapper) {
        this.item = data
        this.LeadService = LeadService
        this.PropertyService = PropertyService
        this.PropertyDealService = PropertyDealService

        this.$onInit = () => {
            this.bookingStatuses = ['PRE_BOOKING', 'BOOKED']
            this.item.buyers = angular.isArray(this.item.buyers) ? this.item.buyers : []
            this.item.items = angular.isArray(this.item.items) ? this.item.items : []
            if (!this.item.id && (!this.item.buyers || this.item.buyers.length === 0)) {
                this.addNextBuyerFn();
            }
        }

        this.hasBuyers = () => angular.isArray(this.item.buyers) && this.item.buyers.length > 0

        this.cancel = () => $uibModalInstance.dismiss('Canceled')
        this.save = () => {
            let toSave = angular.copy(this.item)
            if (this.item.id !== null) {
                return PropertyDeal.update(toSave, onSaveSuccess, () => {
                })
            } else {
                return PropertyDeal.save(toSave, onSaveSuccess, () => {
                })
            }
        };
        let onSaveSuccess = result => {
            $rootScope.$broadcast('property-deal.updated')
            $uibModalInstance.close(result)
            toastr.success("Zapisano")
        };

        this.addNextBuyerFn = () => {
            this.addNextBuyer = true;
            this.nextBuyer = null;
        }
        this.addNextBuyerCancel = () => {
            this.addNextBuyer = false;
            this.nextBuyer = null;
        }

        this.onClientSelected = (value) => {
            if (value) {
                let buyer = PropertyDealBuyerMapper.mapClient(value)
                this.item.buyers = angular.isArray(this.item.buyers) ? this.item.buyers : []
                this.item.buyers.push(buyer)
                this.item.manager = value.managerUsers && value.managerUsers.length === 1 ? value.managerUsers[0] : null
            }
            this.addNextBuyerCancel()
        }

        this.onStatusUpdate = (status) => {
            this.item.status = status;
            delete this.item.booked;
            delete this.item.prebooking;

            switch (status) {
                case 'PRE_BOOKING':
                    this.item.prebooking = {
                        // dateOfIssue: moment().format("YYYY-MM-DD"),
                        // limit: "3"
                    };
                    break;
                case 'BOOKED':
                    this.item.booked = {
                        // agreementDate: moment().format("YYYY-MM-DD"),
                        // limit: "7"
                    };
                    break;
            }
        }
        this.onProjectChanged = () => {
            this.item.items = [];
        }
        this.selectProperty = projectId => {
            let alreadySelectedPropertyIds = this.item.items.map(p => p.property?.id).filter(i => i !== undefined);
            return PropertyService.selectProperty(projectId, alreadySelectedPropertyIds).then(property => {
                if (this.item.items.map(p => p.property?.id).includes(property.id)) {
                    return;
                }
                let dealProperty = {
                    id: property.id,
                    number: property.number,
                    type: property.type,
                    techType: property.techType,
                    floor: property.floor,
                    rooms: property.rooms,
                    windowSide: property.windowSide,
                    livingArea: property.livingArea,
                    livingAreaFinal: property.livingAreaFinal,
                    status: property.status
                }
                if (property.building) {
                    dealProperty.buildingId = property.building.id
                    dealProperty.buildingNumber = property.building.number
                    dealProperty.buildingFloors = property.building.floors
                }
                let attributes = property.attributes.map((attribute) => {
                    delete attribute.id
                    return attribute
                })
                let item = {
                    type: 'ASSET',
                    property: dealProperty,
                    attributes: attributes,
                    calculationBasedOn: property.calculationBasedOn,
                    calculationMethod: property.calculationMethod,
                    vat: property.vat,
                    pricingBase: property.pricingBase,
                    pricingAttributes: property.pricingAttributes,
                    pricing: property.pricing
                }
                this.item.items.push(item);

                property.extraCharges.forEach(extraCharge => {
                    let item = {
                        type: 'EXTRA_CHARGE',
                        propertyId: property.id,
                        name: extraCharge.name,
                        calculationMethod: property.calculationMethod,
                        vat: extraCharge.vat,
                        pricing: extraCharge.pricing
                    }
                    this.item.items.push(item);
                })
            })
        }
    })
